export default __webpack_public_path__ + "static/media/tiktok.03f61c7f.jpg";